import * as React from 'react';

function SvgRugbyLeague(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M4 4h16v16H4z" />
        <path
          d="M18.574 4.241a1.5 1.5 0 011.128 1.03l.03.113a12.046 12.046 0 01-3.277 11.07A12.025 12.025 0 017.925 20c-.842 0-1.693-.089-2.54-.269a1.503 1.503 0 01-1.144-1.157A12.14 12.14 0 017.567 7.567 12.145 12.145 0 0118.574 4.24zM5.085 14.789a11.173 11.173 0 00.137 3.587c.037.183.19.338.373.376 1.211.26 2.434.313 3.624.172L5.085 14.79zm8.505-9.488a11.14 11.14 0 00-5.315 2.974A11.152 11.152 0 005.3 13.59l5.122 5.125a11.069 11.069 0 005.325-2.967 11.057 11.057 0 002.965-5.325L13.59 5.301zm-.737 3.847l.645.645.647-.646a.5.5 0 01.707.707l-.647.646.646.646a.499.499 0 11-.706.707l-.647-.646-.793.793.647.647a.5.5 0 01-.257.844L13 13.5a.5.5 0 01-.353-.147L12 12.706l-.793.793.646.647a.499.499 0 11-.705.707l-.648-.647-.645.647a.5.5 0 01-.258.136l-.095.01a.5.5 0 01-.354-.853l.645-.647-.645-.646a.5.5 0 01.707-.707l.645.646.791-.792-.645-.645a.5.5 0 01.707-.707l.645.645.793-.792-.645-.645a.5.5 0 01.707-.707zM16.16 5c-.46 0-.918.028-1.371.085l4.134 4.135c.14-1.191.088-2.415-.17-3.628a.496.496 0 00-.377-.371A11.245 11.245 0 0016.16 5z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default SvgRugbyLeague;
